





















import Vue from 'vue';

import { Track } from '@/config';

import { STATISTIC_DETAILS } from '../../config';
import Statistic from './statistic.vue';

export default Vue.extend({
  name: 'Statistics',

  components: {
    Statistic,
  },

  props: {
    track: {
      type: Object,
      default: null,
    },
  },

  computed: {
    getStatistics() {
      if (!this.track) {
        return [
          [
            STATISTIC_DETAILS.valence(),
            STATISTIC_DETAILS.acousticness(),
          ],
          [
            STATISTIC_DETAILS.energy(),
            STATISTIC_DETAILS.liveness(),
          ],
          [
            STATISTIC_DETAILS.danceability(),
            STATISTIC_DETAILS.instrumentalness(),
          ],
          [
            STATISTIC_DETAILS.popularity(),
            STATISTIC_DETAILS.speechiness(),
          ],
          [
            STATISTIC_DETAILS.tempo(),
            STATISTIC_DETAILS.added(),
          ],
        ];
      }
      return [
        [
          STATISTIC_DETAILS.valence(this.track.audioFeatures.valence),
          STATISTIC_DETAILS.acousticness(this.track.audioFeatures.acousticness),
        ],
        [
          STATISTIC_DETAILS.energy(this.track.audioFeatures.energy),
          STATISTIC_DETAILS.liveness(this.track.audioFeatures.liveness),
        ],
        [
          STATISTIC_DETAILS.danceability(this.track.audioFeatures.danceability),
          STATISTIC_DETAILS.instrumentalness(this.track.audioFeatures.instrumentalness),
        ],
        [
          STATISTIC_DETAILS.popularity(this.track.audioFeatures.popularity),
          STATISTIC_DETAILS.speechiness(this.track.audioFeatures.speechiness),
        ],
        [
          STATISTIC_DETAILS.tempo(this.track.audioFeatures.tempo),
          STATISTIC_DETAILS.added('added' in (this.track as Track).attatchedData ? (this.track as Track).attatchedData.added as number : 0),
        ],
      ];
    },
  },
});
